import { motion } from "framer-motion";
import {
    Globe,
    Smartphone,
    PencilRuler,
    Wrench,
} from "lucide-react";

const services = [
    {
        icon: Globe,
        title: "Web Development",
        description:
            "Build modern, responsive, and high-performance websites using the latest technologies for an exceptional user experience.",
    },
    {
        icon: Smartphone,
        title: "App Development",
        description:
            "Develop Android and iOS applications with intuitive interfaces, smooth performance, and scalable architecture.",
    },
    {
        icon: PencilRuler,
        title: "UI/UX Design",
        description:
            "Design beautiful, user-friendly interfaces that enhance user engagement and improve customer satisfaction.",
    },
    {
        icon: Wrench,
        title: "Maintenance & Support",
        description:
            "Keep your applications secure, updated, optimized, and running smoothly with our ongoing maintenance services.",
    },
];

export default function Services() {
    return (
        <section className="pt-16 bg-gradient-to-r from-white via-blue-50 to-white">
            <div className="max-w-7xl mx-auto px-6">

                {/* Heading */}
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: .8 }}
                    className="text-center mb-16"
                >
                    <span className="text-[#075DA8] font-bold uppercase tracking-widest text-lg">
                        What We Do
                    </span>

                    <h2 className="text-5xl font-bold text-gray-900 mt-4">
                        Our Services
                    </h2>

                    <p className="mt-6 text-xl text-gray-600 max-w-3xl mx-auto">
                        We offer end-to-end technology solutions to help businesses
                        grow faster and succeed in the digital world.
                    </p>
                </motion.div>

                {/* Service Cards */}
                <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">

                    {services.map((service, index) => {
                        const Icon = service.icon;

                        return (
                            <motion.div
                                key={index}
                                initial={{ opacity: 0, y: 40 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{
                                    duration: .6,
                                    delay: index * .15,
                                }}
                                whileHover={{
                                    y: -12,
                                    scale: 1.03,
                                }}
                                className="relative bg-blue-50 rounded-[30px] p-8 text-center shadow-sm hover:shadow-xl transition-all duration-300"
                            >
                                {/* Icon */}
                                <div className="w-28 h-28 mx-auto rounded-full bg-white flex items-center justify-center shadow-md">
                                    <Icon
                                        size={50}
                                        className="text-[#075DA8]"
                                    />
                                </div>

                                {/* Title */}
                                <h3 className="text-2xl font-semibold text-gray-900 mt-8">
                                    {service.title}
                                </h3>

                                {/* Description */}
                                <p className="mt-5 text-gray-600 leading-8">
                                    {service.description}
                                </p>
                            </motion.div>
                        );
                    })}

                </div>

            </div>

            {/* ===== WHY MSM TECHNOLOGIES ===== */}
            <div className="w-full bg-[#075DA8] text-white py-16 my-10">
                <div className="max-w-4xl mx-auto px-6">
                    <h2 className="text-3xl font-semibold text-center mb-12">
                        Why MSM Technologies?
                    </h2>

                    <div className="grid justify-content-center grid-cols-1 md:grid-cols-2 gap-5">

                        {/* ITEM */}
                        <div className="flex gap-4">
                            <span className="text-2xl">✔</span>
                            <div>
                                <h4 className="font-semibold">
                                    Experienced Development Team
                                </h4>
                                {/* <p className="text-sm opacity-90 mt-1">
                                    MSM Technologies has transformed the careers of thousands of students,
                                    turning their ambitions into achievements.
                                </p> */}
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="text-2xl">✔</span>
                            <div>
                                <h4 className="font-semibold">
                                    Modern & Responsive Designs
                                </h4>
                                {/* <p className="text-sm opacity-90 mt-1">
                                    From industry projects to continuous placement guidance, we prepare
                                    learners for the corporate world.
                                </p> */}
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="text-2xl">✔</span>
                            <div>
                                <h4 className="font-semibold">
                                    Dedicated Customer Support
                                </h4>
                                {/* <p className="text-sm opacity-90 mt-1">
                                    Our strong placement network offers students excellent opportunities
                                    across leading companies.
                                </p> */}
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="text-2xl">✔</span>
                            <div>
                                <h4 className="font-semibold">
                                    SEO-Friendly Solutions
                                </h4>
                                {/* <p className="text-sm opacity-90 mt-1">
                                    Small batch sizes ensure individual attention and better concept clarity.
                                </p> */}
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="text-2xl">✔</span>
                            <div>
                                <h4 className="font-semibold">
                                    Scalable & Secure Applications
                                </h4>
                                {/* <p className="text-sm opacity-90 mt-1">
                                    Our trainers bring real-time corporate experience, providing practical and up-to-date industry knowledge.
                                </p> */}
                            </div>
                        </div>

                        <div className="flex gap-4">
                            <span className="text-2xl">✔</span>
                            <div>
                                <h4 className="font-semibold">
                                    100% Client Satisfaction Focus
                                </h4>
                                {/* <p className="text-sm opacity-90 mt-1">
                                    Our trainers bring real-time corporate experience, providing practical and up-to-date industry knowledge.
                                </p> */}
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}